<template>

	<div v-if='show'>
		<vx-card style="padding-bottom: 20px">
			<div>
				<div class="float-left" v-if='isModeratorOrAdmin && timer.user_id'>
					<input
						@input.prevent="handleTimerInput"
						@keydown.backspace="handleTimerInputBack"
						@keydown="handleTimerKeydown"
						v-model='timer.minutes'
						autocomplete="off"
						data-lpignore="true"
						ref="timer-min"
						class="w-10 mb-3 rounded border border-gray-200 p-2 text-center appearance-none"
						type="text"
						maxlength="2"
						:readonly='timer.readonly'
					>
					<b class='mr-1 ml-1'>:</b>
					<input
						@input.prevent="handleTimerInput"
						@keydown.backspace="handleTimerInputBack"
						@keydown="handleTimerKeydown"
						v-model='timer.seconds'
						autocomplete="off"
						data-lpignore="true"
						ref="timer-sec"
						class="w-10 mb-3 rounded border border-gray-200 p-2 text-center appearance-none"
						type="text"
						maxlength="2"
						:readonly='timer.readonly'
					>
					<b class='pl-4 text-center'>{{ timer.username }}</b>
					<vs-button class='vs-button-success ml-3' @click.prevent='startTimerSubmit()'>{{
							$t('Submit')
						}}
					</vs-button>
					<vs-button class='vs-button-danger ml-1' @click.prevent='startTimerCancel()'>{{
							$t('Cancel')
						}}
					</vs-button>
				</div>

				<div class="float-left" v-else-if='timerLeft.user_id'>
					<input
						v-model='timerLeft.minutes'
						class="w-10 mb-3 rounded border border-gray-200 p-2 text-center appearance-none"
						type="text"
						readonly='true'
					>
					<b class='mr-1 ml-1'>:</b>
					<input
						v-model='timerLeft.seconds'
						class="w-10 mb-3 rounded border border-gray-200 p-2 text-center appearance-none"
						type="text"
						readonly='true'
					>
					<b class='pl-4 text-center'>{{ timerLeft.username }}</b>
					<vs-button v-if='isModeratorOrAdmin' class='vs-button-danger ml-3' @click.prevent='stopTimer()'>{{
							$t('Stop')
						}}
					</vs-button>
				</div>
				<div class="d-flex">
					<template>
							<span v-if="event_detail.is_auto_speaker == 1 && !isSpeaker && !isModeratorOrAdmin">
								<span class="list ml-2 cursor-pointer" v-if="!audio">
									<feather-icon
										icon="MicIcon"
										svgClasses="w-7 h-7 hover:text-danger stroke-current"
										@click="muteAudio()"
									/>
								<!-- <vx-tooltip text="Mute">
								</vx-tooltip> -->
							</span>
							<span class="list ml-2 cursor-pointer" v-else>
									<feather-icon
										icon="MicOffIcon"
										svgClasses="w-7 h-7 hover:text-danger stroke-current"
										@click="muteAudio()"
									/>
								<!-- <vx-tooltip text="Unmute">
								</vx-tooltip> -->
							</span>
							<span class="list ml-2 cursor-pointer" v-if="!video">
									<feather-icon
										icon="VideoIcon"
										svgClasses="w-7 h-7 hover:text-danger stroke-current"
										@click="muteVideo()"
									/>
								<!-- <vx-tooltip text="On">
								</vx-tooltip> -->
							</span>
							<span class="list ml-2 cursor-pointer" v-else>
									<feather-icon
										icon="VideoOffIcon"
										svgClasses="w-7 h-7 hover:text-danger stroke-current"
										@click="muteVideo()"
									/>
								<!-- <vx-tooltip text="Off">
								</vx-tooltip> -->
							</span>
						</span>
						<span>
						
							<span v-if="!isModeratorOrAdmin">
								<img
                  data-tour='step-7'
									@click='handToggle()'
									v-if='!isHandRaised'
									src="@/assets/images/Hands-Down-icon.png"
									alt="Hand Down"
									class="float-right participant-icon cursor-pointer"
								/>
								<img
                  data-tour='step-7'
									v-else
									@click='handToggle()'
									src="@/assets/images/Hands-icon-raised.png"
									alt="Hand Raised"
									class="float-right participant-icon cursor-pointer"
								/>
							</span>
							<img
                data-tour='step-6'
								@click.prevent='showHideParticipant()'
								src="@/assets/images/participant-icon-png-participant.png"
								alt="Participants"
								class="float-right participant-icon cursor-pointer"
							/>
							</span>
					</template>
				</div>
			</div>
		</vx-card>
		<div
			v-if="showParticipants"
			class="container home-card border border-solid d-theme-dark-border rounded custom-card-css"
					:style="{'margin-top':'1%','background-image': `url(${ require('@/assets/images/bg-chat-tile-light.png') })`, 'background-repeat': 'repeat'}">
			<!-- <div id="chat-app" class="pt-2"> -->
				<!-- Chat Messages Start here -->
				<div v-if='isEventChatable' class="chat__contact flex items-center px-2 pt-4 pb-2">
					<div class="contact__avatar mr-1">
						<avatar
							:size="35"
							:username='chatUser | displayName'
						>
						</avatar>
					</div>
					<div class="contact__container w-full flex items-center justify-between overflow-hidden">
						<div>
							<!-- w - 4 / 6 -->
						<div
							class="contact__info flex flex-col truncate"
						>
								<p class="font-semibold cursor-pointer">{{ chatUser | displayName }}</p>
							</div>
						</div>
					</div>
				</div>

				<ul class="text-sm chat_align_botom w-full" ref="messagesContainer" v-if='isEventChatable'>
					<template v-for="(message, index) in messageList">
						<li
							v-if="isMessagePublic(message)"
							:class="{ 'text-right': message.sender_user_id == myself.id }"
							:style="'margin: 30px'"
							:key="index"
						>
								<small v-if="message.sender_user_id != myself.id">{{ message.sender_user| displayName }}</small>
							<small> {{ message.created_at | displayDate }}</small>
							<br />
								<a class="chat-message"><span class="message-span"
									:class="{
										'message-span-right': message.sender_user_id == myself.id,
									}"
								>
									{{ message.message }}<br
								/></span>
								</a>
							</li>
					</template>
				</ul>
			<div v-if='isEventChatable'
				class="chat-input-div centerx default-input vx-row w-full"
				style="padding-right: 315px"
			>
				<div class="vx-col md:w-3/4 xl:w-5/6 custom-input-chat-div mt-5">
					<vs-input
						class="w-full"
						placeholder="Type a message"
						v-model="message"
						v-on:keyup.enter="sendMessage()"
					></vs-input>
				</div>
				<div class="md:w-1/4 xl:w-1/6 mt-5 custom-input-chat-div-button">
					<vs-button
						:disabled="isDisabled"
						class="w-full chat-button"
						@click="sendMessage()"
						>Send</vs-button
					>
					</div>
				</div>
				<!-- Chat Messages End here -->
			<div id="chat-app" class="pt-2">
				<vs-sidebar
					:hiddenBackground="true"
					:positionRight="true"
					v-model="showParticipants"
					id="chat-list-sidebar" class="items-no-padding" parent="#chat-app">

					<!-- Recent Chat list Start-->
					<div class="chat__contacts pt-3" v-if='isEventChatable'>
						<b class="text-lg text-primary mb-3 px-4">{{ $t("Chat") }} </b>
						<ul class="chat__contacts bordered-items text-sm">
							<li class="">
								<div @click="createUserData('')" class="chat__contact flex items-center px-2 pt-4 pb-2">
									<div class="contact__avatar mr-1">
										<avatar :size="35" :username="slug"> </avatar>
									</div>
									<div class="contact__container w-full flex items-center justify-between overflow-hidden">
										<div class="contact__info flex flex-col truncate w-full">
											<p class="font-semibold cursor-pointer">{{ slug }}	<small class="pull-right"	v-if="chatList.	group_chat != null">
													{{ chatList.group_chat.created_at | displayDate }}
												</small>
											</p>
											<small v-if="chatList.group_chat != null">{{ chatList.group_chat.message }}</small>
										</div>
									</div>
								</div>
							</li>
							<li class="" v-for="data in chatList.event_chat" :key="data.id">
								<div @click="createUserData(data.user_data)" class="chat__contact flex items-center px-2 pt-4 pb-2">
									<div class="contact__avatar mr-1">
										<avatar
											:size="35"
											:username="data.user_data | displayName"
										>
										</avatar>
									</div>
									<div class="contact__container w-full flex items-center justify-between overflow-hidden">
										<div class="contact__info flex flex-col truncate w-full">
											<p class="font-semibold cursor-pointer">{{ data.user_data | displayName }}
												<small class="pull-right">{{
													data.created_at | displayDate
												}}</small>
											</p>
											<small>{{ data.message }}</small>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<!-- Recent chat List end -->
<!-- :key="$vs.rtl" class="chat-scroll-area pt-4"	:settings="{ maxScrollbarLength: 60, wheelSpeed: 0.7 }" -->
					<!-- <div > -->
						<div class="chat__contacts pt-3">
							<b class="text-lg text-primary mb-3 px-4"
								>{{ $t("Participants") }} ({{ onlineParticipants.length }})
							</b>

							<vs-input class='w-full mt-3 px-2 mt-1' :value='search_participants' v-debounce:1s="searchInput" :icon-after='true' icon="search" placeholder=""/>
							
						</div>

						<VuePerfectScrollbar :key="$vs.rtl" :settings="{ maxScrollbarLength: 60, wheelSpeed: 0.7 }"  class="chat-scroll-area pt-4">
							<ul class="chat__contacts bordered-items text-sm">
								<li class="text-sm" v-for="(participant,idx) in onlineParticipants" :key="idx">
									<!-- :class="{'bg-primary-gradient text-white shadow-lg': isActiveChatUser}" -->

									<div class="chat__contact flex items-center px-2 pt-4 pb-2">
										<div class="contact__avatar mr-1">
											<avatar
												:size="35"
												:username='participant | displayName'
											>
												<!-- <img src="src" alt="alt"> -->
											</avatar>
											<!-- <vs-avatar class="border-2 border-solid border-white" :src="require('@/assets/images/user-default-avatar.png')" size="42px" /> -->
										</div>
										<div class="contact__container w-full flex items-center justify-between overflow-hidden">

											<component ref='participant_el' vs-trigger-click :is='myself.id != participant.user_id ? "vs-dropdown" : "div"'>
												<div class="contact__info flex flex-col truncate"
													:class="{'w-4/6': isModeratorOrAdmin,'w-6/6': !isModeratorOrAdmin}"
												>
													<p class="font-semibold cursor-pointer text-sm">{{ participant | displayName }}</p>
													<small v-if="participant.is_moderator" class="mt-1 text-left">{{ $t('Moderator') }}</small>
													<small v-else-if="participant.is_speaker" class="mt-1 text-left">{{ $t('Speaker') }}</small>
													<small v-else-if="participant.user_role && participant.user_role=='admin'" class="mt-1 text-left">{{ $t('Admin') }}</small>
												</div>
												<vs-dropdown-menu v-if="myself.id != participant.user_id">
													<template v-if="isModeratorOrAdmin && participant.user_role!='admin' && participant.user_role!='admin_observer'">
														
														<vs-dropdown-item
															@click.prevent='onlineUserClicked(participant)'
															v-if="!participant.is_speaker"
														>{{ $t('PromoteToSpeaker') }}
														</vs-dropdown-item>
														<vs-dropdown-item
															v-if='participant.is_speaker'
															@click.prevent='onlineUserClicked(participant)'
														>{{ $t('ReturnToUser') }}
														</vs-dropdown-item>
														<vs-dropdown-item
															v-if='participant.is_speaker'
															@click.prevent='startTimer(participant)'
														>
															{{ $t('StartTimer') }}
														</vs-dropdown-item>
														<vs-dropdown-item
															@click.prevent='handToggle(participant.user_id)'
															v-if='participant.hand_raised'
														>{{ $t('HandsDown') }}
														</vs-dropdown-item>

														<template v-if='participant.is_speaker == 1 && event_detail && event_detail.is_bne_room == 1'>
															<vs-dropdown-item
																@click.prevent='blockUnmute(participant)'
																v-if="participant.block_unmute"
															>{{ $t('UnBlockUnmute') }}
															</vs-dropdown-item>
															<vs-dropdown-item
																@click.prevent='blockUnmute(participant)'
																v-else
															>{{ $t('BlockUnmute') }}
															</vs-dropdown-item>

															<vs-dropdown-item
																v-if='participant.is_muted == 0'
																@click.prevent='muteUser(participant, true)'
															>{{ $t('Mute') }}
															</vs-dropdown-item>
															<vs-dropdown-item
																v-else
																@click.prevent='muteUser(participant, false)'
															>{{ $t('Unmute') }}
															</vs-dropdown-item>
														</template>
													</template>
													<vs-dropdown-item
														v-if='isEventChatable'
														@click.prevent='chatUserData(participant)'
													>{{ $t('SendMessage') }}
													</vs-dropdown-item>
												</vs-dropdown-menu>

											</component>


											<div class="contact__info flex flex-col truncate w-2/6"
														v-if='isModeratorOrAdmin && participant.hand_raised'>
												<img src="@/assets/images/Hands-icon-raised.png" alt="Hand-Raised"
															style='float:right;width:20px;'>
											</div>
										</div>
									</div>

									<!-- <chat-contact :contact="contact"></chat-contact> -->
								</li>
							</ul>
						</VuePerfectScrollbar>
					<!-- </div> -->
				</vs-sidebar>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Avatar from 'vue-avatar';
import moment from "moment";
import EventTypes from "@/utils/event-types";
import { getTime } from '../../api/settings';
import { toggleBlockUnmuteSpeaker } from '@/api/event';

const sortAtoZParticipants = (participantA, participantB) => {
	const textA = participantA.first_name.toUpperCase();
	const textB = participantB.first_name.toUpperCase();
	return textA < textB ? -1 : textA > textB ? 1 : 0;
};

const searchParticipants = (search,participant) => {
	if(search.length > 0)
		return (participant.first_name+' '+participant.last_name).toUpperCase().indexOf(search) > -1
	else
		return true;
};

export default {
	name: 'EventParticipants',
	props: {slug:String},
	components: {VuePerfectScrollbar, Avatar},
	data() {
		return {
			message: "",
			messageList: [],
			chatList: [],
			isDisabled: false,
			chatUser: null,
			showParticipants: false,
			search_participants: '',
			EventParticipantsrunningSpeakerClock: null,
			timerLeft: {
				minutes: '00',
				seconds: '00',
				user_id: null,
				username: null
			},
			timer: {
				minutes: '00',
				seconds: '00',
				user_id: null,
				username: null,
				readonly: false
			},
			audio: true,
			video: true,
		}
	},
	computed: {
		...mapGetters([
			'event_listener',
			'event_detail',
			'myself',
			'isModeratorOrAdmin',
			'isSpeaker',
			'isModerator',
			'participants',
			'isHandRaised',
      'isTourStarted',
      'tour_curr_step'
		]),
		isEventChatable() {
			return EventTypes.findIndex(et => {
				return et.isChatable && et.value==this.event_detail.event_type;
			}) > -1;
		},
		show() {
			const event = this.event_detail;
			return event && (event.status == 1 || (event.status == 3 && (this.isSpeaker || this.isModeratorOrAdmin)))
		},
		onlineParticipants() {
			const search = this.search_participants.toUpperCase();
			const result = [];
			const online_participants = [];

			this.participants.filter(p => p.online)
			.forEach(p => {
				for(let i=1; i<=p.online_count; i++) {
					online_participants.push(p)
				}
			})

			// extract myself from participants
			online_participants
			.filter((p) => p.user_id == this.myself.id)
			.forEach((p) => {
				result.push(p);
			});

			let op = online_participants
			// .filter((p) => p.online)
			.filter((p) => p.user_id != this.myself.id)
			.filter(_ => searchParticipants(search,_))
			.sort(sortAtoZParticipants);

			// raised hands
			op.filter(p => !p.is_moderator && p.hand_raised != null)
			.sort((a,b) => {
				if (this.isModeratorOrAdmin) {
					if (a.hand_raised && b.hand_raised)
							return a.hand_raised - b.hand_raised;
					if (a.hand_raised) return -1;
					if (b.hand_raised) return -1;
				}
				return 0;
			}).forEach(p => { result.push(p) });


			// moderators
			op.forEach(p => {
				if(p.is_moderator)
					result.push(p);
			});

			// speakers
			op.forEach(p => {
				if(p.hand_raised==null && p.is_speaker && !p.is_moderator)
					result.push(p);
			});

			// extract normal users
			let pushedIds = result.map(p => p.user_id);

			// console.log('pushed_id', pushedIds);
			op.forEach(p => {
				if(pushedIds.indexOf(p.user_id) < 0)
					result.push(p);
			});
			return result;
		},
		diffTime() {
			return this.$store.state.app.serverTimeDifference;
		}
	},
	watch: {
    show() { 
      this.updateStatusOfTourResolver();
    },
    tour_curr_step: function(step) {
      if(step==7)
        !this.isModeratorOrAdmin ? this.showHideParticipant() : '';
      if(step==8)
        this.handToggle();
    },
    isModeratorOrAdmin: function(okay) {
      if(okay && this.isTourStarted)
        this.$store.commit('ADD_TOUR_SKIP_STEP', 7);
    },
		event_listener: function(listen) {
			switch(listen.key) {
				case 'EventSpeakerTimerUpdate':
          			this.setSpeakerClock(listen.payload.user_id,	listen.payload.start_time,	listen.payload.end_time);
					break;
				case 'EventChatMessage':
					this.chatMessageUpdates(listen.payload); 
					break;
				default: break;
			}
		}
	},
	async created() {
		
		this.chatUser = {first_name: this.slug, last_name: '', user_id: "0"}
		// try {
    //   const beforeRequestTime = new Date();
    //   const res = await getTime();
    //   const dt = new Date();

    //   if(this.$route.query.method == 2) {
    //     // ref: https://gist.github.com/ethaizone/6abb1d437dbe406fbed6
    //     const serverClientRequestDiffTime = res.data.timestamp - beforeRequestTime.getTime();
    //     const serverClientResponseDiffTime = dt.getTime() - res.data.timestamp;
    //     const responseTime = (serverClientRequestDiffTime - dt.getTime() + beforeRequestTime.getTime() - serverClientResponseDiffTime )/2;
    //     this.diffTime = (serverClientResponseDiffTime - responseTime);
    //   }else {
    //     this.diffTime = dt.getTime() - res.data.timestamp;
    //   }

    // }catch(e) {
    //   console.error(e);
    // }
	},
	async mounted() {
		this.$store.dispatch('getSpeakerTimer', this.event_detail.id)
		.then(response => {
			if(response.data.status == 'success' && response.data.data)
				this.setSpeakerClock(response.data.user_id,	response.data.start_time,	response.data.end_time);
		});
		await this.getChatList();
		this.getUserMessages();
    this.updateStatusOfTourResolver();
	},
	methods: {
    updateStatusOfTourResolver() {
      if(!(this.isTourStarted && this.show))
        return false
      this.$store.commit('SET_TOUR_VISIBILITY',true);
      for(let step=6;step<9;step++) {
        this.$store.commit('UPDATE_TOUR_RESOLVER_STATUS', {status:true, message: 'GO AHEAD!', step: step})
      }
    },
		chatMessageUpdates(payload) { 
			if (payload.receiver_user_id == null) {
				if(this.isMessagePublic(payload)) {
				  this.messageList.push(payload);
				  this.getChatList();
				  this.scrollToEnd();
				}
			} else{
			  const participant = this.participants.find(
				(p) => p.user_id == payload.receiver_user_id
			  );
			  if(participant == undefined)
				return;
			  this.messageList.push(payload);
			  this.getChatList();
			  this.scrollToEnd();
			}
		},
		muteAudio() {
			this.audio = !this.audio;
			this.markAsSpeakerFromUser(this.$store.getters.currentUser.id, this.audio ? 1 : 0);
			// this.isSpeaker = this.audio ? 1 : 0;
		},
		muteVideo() {
			this.video = !this.video;
			this.markAsSpeakerFromUser(this.$store.getters.currentUser.id, this.audio ? 1 : 0);
			// this.isSpeaker = this.audio ? 1 : 0;
		},
		async muteUser(participant, status){
			const req = {
				user_id: participant.user_id,
				is_muted: status,
				event_id: this.event_detail.id,
				is_save: true
			};

			try{
				await this.$store.dispatch("updateMuteStatus", req);
			}catch(err) { 
				console.error(err);
				this.$vs.notify({
					title: 'User mute/unmute failed',
					text: null,
					color: "danger",
					position: "top-center",
				});
			}
		},
		searchInput(e) {
			this.search_participants = e;
		},
		getTime() {
			const dt = new Date();
			dt.setTime(dt.getTime() + this.diffTime);
			return dt;
		},
		startTimer(participant) {
			this.timer = Object.assign(this.timer, {
				user_id: participant.user_id,
				username: this.$options.filters.displayName(participant)
			});
			this.$nextTick(() => {
				this.$refs['timer-min'].scrollIntoView();
				this.$refs['timer-min'].focus();
			})
			return false;
		},
		startTimerSubmit() {
			const seconds = Number(this.timer.seconds);
			const minutes = Number(this.timer.minutes);
			if (minutes < 0 || seconds < 0 || (minutes == 0 && seconds == 0)) {
				// show validation error here
				return false;
			}
			this.dispatchTimerCommand({
				event_id: this.event_detail.id,
				user_id: this.timer.user_id,
				minutes: minutes,
				seconds: seconds
			});
		},
		stopTimer() {
			this.dispatchTimerCommand({
				event_id: this.event_detail.id,
				user_id: this.timerLeft.user_id,
				minutes: null,
				seconds: null
			});
		},
		async dispatchTimerCommand(req) {
			try {
				const response = await this.$store.dispatch('eventStartSpeakerTime', req);
				this.timer.user_id = null;
			} catch (error) {
				console.error(error);
				this.$vs.notify({
					title: this.$t("EventLoadError"),
					text: error,
					color: "danger",
					position: "top-center"
				});
			}
		},
		startTimerCancel() {
			this.timer = Object.assign(this.timer, {
				user_id: null,
				username: null
			});
		},
		async onlineUserClicked(oparticipant) {
			console.log(oparticipant)
			if (!this.isModeratorOrAdmin)
				return false;
			const participant = this.participants.find(p => oparticipant.user_id == p.user_id);
			if (typeof participant == 'undefined')
				return false;

			const prmpt = await this.$swal({
				title: `<strong>${participant.is_speaker == 1 ? this.$t("PromptDemoteToSpeaker") : this.$t("PromptPromoteToSpeaker")}</strong>`,
				confirmButtonText: this.$t("Yes"),
				cancelButtonText: this.$t("No"),
				showCancelButton: true
			});

			if (prmpt.isConfirmed) {
				let spk = participant.is_speaker == 1 ? 0 : 1
				//participant.hand_raised = null;
				this.markAsSpeaker(participant.user_id, spk);
			}

		},
		async markAsSpeaker(user_id, is_speaker) {
			try {
				const response = await this.$store.dispatch('eventMarkAsSpeaker', {
					event_id: this.event_detail.id,
					user_id: user_id,
					is_speaker: is_speaker
				});
			} catch (error) {
				console.error(error);
				this.$vs.notify({
					title: this.$t("EventLoadError"),
					text: error,
					color: "danger",
					position: "top-center"
				});
			}
		},
		async markAsSpeakerFromUser(user_id, is_speaker) {
			try {
				const response = await this.$store.dispatch('eventMarkAsSpeakerFromUser', {
					event_id: this.event_detail.id,
					user_id: user_id,
					is_speaker: is_speaker
				});
			} catch (error) {
				console.error(error);
				this.$vs.notify({
					title: this.$t("EventLoadError"),
					text: error,
					color: "danger",
					position: "top-center"
				});
			}
		},
		chatUserData(userData) {
			if (userData.first_name == undefined)
				this.chatUser = {first_name: this.slug, last_name: '', user_id: "0"};
			else this.chatUser = userData;
			this.getUserMessages();
		},
		createUserData(userData) {
			if (userData.first_name == undefined)
				this.chatUser = {first_name: this.slug, last_name: "", user_id: "0"};
			else
				this.chatUser = {
					first_name: userData.first_name,
					last_name: userData.last_name,
					user_id: userData.id,
				};
			this.getUserMessages();
		},
		getUserMessages() {
			if (this.event_detail.id) {
				this.$store
					.dispatch("getMessageList", {
						event_id: this.event_detail.id,
						receiver_user_id: [this.chatUser.user_id, this.myself.id],
					})
					.then((resp) => {
						this.messageList = resp.data.data.event_chat;
						this.scrollToEnd();
					})
					.catch((error) => {
						console.error(error);
						this.$vs.notify({
							title: this.$t("Error"),
							text:
								this.$t(error.replace(/[\s\/]/g, "")) !==
								error.replace(/[\s\/]/g, "")
									? this.$t(error.replace(/[\s\/]/g, ""))
									: error,
							color: "danger",
							position: "top-center",
						});
					});
			}
		},
		async getChatList() {
			try{
				const resp = await this.$store.dispatch("getChatList", {
					event_id: this.event_detail.id,
					receiver_user_id: this.myself.id,
				});
				this.chatList = resp.data.data;
			}catch(e) {
				console.error(e);
				const msg = this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "") ? this.$t(error.replace(/[\s\/]/g, "")) : error
				this.$vs.notify({
					title: this.$t("Error"),
					text: msg,
					color: "danger",
					position: "top-center",
				});
			}
		},
		scrollToEnd() {
			setTimeout(() => {
					var content = this.$refs.messagesContainer;
				if (content) content.scrollTop = content.scrollHeight;
			}, 100);
		},
		showHideParticipant() {
			this.showParticipants = !this.showParticipants;
			this.scrollToEnd();
			this.createUserData("");
		},
		async sendMessage() {
			try {
				this.isDisabled = true;
				let formdata = new FormData();
				formdata.append("message", this.message);
				formdata.append("sender_user_id", this.myself.id);
				formdata.append("receiver_user_id", this.chatUser.user_id);
				formdata.append("event_id", this.event_detail.id);
				if (this.message != "") {
					const response = await this.$store.dispatch(
						"saveEventChat",
						formdata
					);
					this.getChatList();
					this.message = "";
					this.isDisabled = false;
				} else {
					this.isDisabled = false;
				}
			} catch (error) {
				console.error(error);
				this.$vs.notify({
					title: this.$t("EventLoadError"),
					text: error,
					color: "danger",
					position: "top-center",
				});
				this.isDisabled = false;
			}
		},
		async handToggle(user_id = null) {
			// this.handRaised = !this.handRaised;
			try {
				const response = await this.$store.dispatch('eventHandRaised', {
					hand_raised: !this.isModeratorOrAdmin && !this.isHandRaised ? (new Date()).getTime() : null,
					event_id: this.event_detail.id,
					user_id: this.isModeratorOrAdmin ? user_id : null
				});
			} catch (error) {
				console.error(error);
				this.$vs.notify({
					title: this.$t("EventLoadError"),
					text: error,
					color: "danger",
					position: "top-center"
				});
			}
		},
		setSpeakerClock(user_id = null, start_time = null, end_time = null) {
			if (this.runningSpeakerClock) {
				clearInterval(this.runningSpeakerClock);
				this.runningSpeakerClock = null;
				this.timer.user_id = this.timerLeft.user_id; // swap value
				this.timerLeft.user_id = null;
			}

			if (!user_id)
				return false;

			const participant = this.participants.find(p => p.user_id == user_id);
			if (!participant)
				return false;

			const end_time_obj = new Date(end_time);
			const now = this.getTime();

			if (end_time_obj.getTime() > now.getTime()) {
				// we should start timer here

				this.timerLeft = Object.assign(this.timerLeft, {
					user_id: user_id,
					username: this.$options.filters.displayName(participant)
				});
				this.calculateSpeakerTimer(end_time_obj, now);
				this.runningSpeakerClock = setInterval(() => {
					const newTime = this.getTime();
					if (newTime.getTime() >= end_time_obj.getTime()) {
						this.setSpeakerClock();
					} else
						this.calculateSpeakerTimer(end_time_obj, newTime);

				}, 1000);
			}

		},
		calculateSpeakerTimer(end_time, now_time) {
			const diffTime = Math.abs(end_time.getTime() - now_time.getTime()) / 1000;
			const minutes = Math.floor(diffTime / 60);
			const seconds = Math.floor(diffTime % 60);
			this.timerLeft.minutes = minutes > 9 ? minutes : '0' + minutes.toString();
			this.timerLeft.seconds = seconds > 9 ? seconds : '0' + seconds.toString();
		},
		handleTimerInput(ev) {
			return 60;
			const value = ev.target.value;
			console.log(value, isNaN(value));
			if (isNaN(value)) return false;
			if (Number(value) < 0)
				return false;
			if (ev.target === this.$refs["timer-min"]) {
				if (value.length > 1) {
					this.$nextTick(() => {
						this.$refs["timer-sec"].focus();
					});
				}
			}
			return true;
		},
		handleTimerInputBack(ev) {
			if (ev.target.value.length < 1 && ev.target === this.$refs["timer-sec"]) {
				this.$nextTick(() => {
					this.$refs["timer-min"].focus();
				});
			}
			return true;
		},
		handleTimerKeydown(e) {
			const validKey = [8, 9, 16];
			const isNumeric = (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || validKey.indexOf(e.keyCode) > -1;
			if (!isNumeric)
				e.preventDefault();
			else {
				setTimeout(() => {
					if (this.timer.seconds > 59) {
						this.timer.minutes =
							Number(this.timer.minutes) + Math.floor(this.timer.seconds / 60);
						this.timer.seconds = Math.ceil(this.timer.seconds % 60);
					}
				}, 500);
			}
		},
		isMessagePublic(message) {
			const publicChat = EventTypes.findIndex(et => {
				return et.isPublicChat && et.value==this.event_detail.event_type;
			}) > -1;

			if(message.sender_user_id==this.myself.id || message.receiver_user_id != null || this.isModeratorOrAdmin || this.isSpeaker || publicChat)
				return true;
			console.log('Hey')
			return this.participants.findIndex(p => 
				p.user_id==message.sender_user_id && (p.is_speaker == 1 || p.is_moderator || ['admin','admin_observer'].indexOf(p.user_role) > -1)
			) > -1
		},
		blockUnmute(participant) {
			console.log(participant);
			toggleBlockUnmuteSpeaker(this.event_detail.id, participant.id);
		}
	}
}
</script>
<style lang="scss" scoped>

	/* start by luca */
	.container {
		position: relative;
		overflow: hidden;
		width: 100%;
		padding-top: unset;
		border-radius: 5px;
	}

	@media only screen and (max-width: 992px) {
		.conference .home-card {
			height: 600px;
		}
	}

	@media (min-width: 576px) {
		.container {
			max-width: unset;
			height: 600px;
		}
	}

	@media only screen and (max-width: 767px) {
		#chat-list-sidebar .vs-sidebar {
			position: static;
			max-width: none !important;
		}
		.chat_align_botom {
			position: static !important;
			padding-right: 0px !important;
			max-height: 375px !important;
		}
		.chat-input-div {
			padding-right: 0px !important;
			position: unset !important;
		}
		.custom-card-css {
			height: auto !important;
			padding: 0;
		}
		.custom-input-chat-div {
			width: 80%;
			padding-left: 2rem !important;
		}
		.custom-input-chat-div-button {
			width: 20%;
		}
		.chat-button {
			padding: 0.75rem 0rem !important;
		}
	}

	/* end by luca */
	.participant-icon {
		width: 3%;
		max-width: 28px;
	}

	.message-span {
		background: #fff;
		color: #000;
		padding: 15px 27px;
		border-radius: 0px 25px 25px 25px;
		box-shadow: 1px 1px 10px #ddd;
		display: inline-block;
		text-align: justify;
	}

	.message-span-right {
	border-radius: 25px 25px 0px 25px;
	text-align: left !important;
	}

	.chat_align_botom {
	max-height: 435px;
	overflow-y: scroll;
	padding: 20px 314px 20px 0px;
	position: absolute;
	bottom: 100px;
	width: 100%;
	}

	.chat-input-div {
	position: absolute;
	bottom: 10px;
	}

	.vs-button {
		margin-right: 20px !important;
		text-align: center;
	}
	/*=========================================================================================
			File Name: chat.scss
			Description: Chat app's styles. This is imported in Chat.vue file
			----------------------------------------------------------------------------------------
			Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
				Author: Pixinvent
			Author URL: http://www.themeforest.net/user/pixinvent
	==========================================================================================*/
	#chat-app {
		.vs-sidebar--background {
			position: absolute;
			z-index: 40000;
		}

		#chat-list-sidebar,
		#chat-profile-sidebar {
			.vs-sidebar {
				max-width: 300px;
			}
		}

		#chat-list-sidebar {

			.chat-scroll-area {
				position: relative;
				margin: auto;
				width: 100%;
				height: 70%;
				// overflow: auto;
				&:not(.ps) {
					overflow-y: auto;
					height: calc(100%+10px);
				}

				.chat__contact {
					transition: background-color .1s;

					&:hover {
						background-color: #eee;
					}
				}
			}
		}
	}
</style>
